module.exports = __webpack_public_path__ + "static/media/IFCALOGO.d1d0fb50.svg";